import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useSEO } from "@/hooks/useSEO";

export default function NotFoundPage() {
  useSEO({
    title: "Page introuvable — Express Delivery",
    description: "Cette page n'existe pas ou n'est plus disponible.",
    path: "/404",
    isIndexable: false,
  });

  return (
    <div data-testid="not-found-page">
      <Header />
      <section className="pt-32 pb-24 px-4 md:px-8 max-w-2xl mx-auto text-center">
        <p className="text-orange font-heading font-extrabold text-6xl mb-4">404</p>
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-navy mb-4">Page introuvable</h1>
        <p className="text-muted-foreground mb-8">
          La page que vous recherchez n'existe pas ou n'est plus disponible.
        </p>
        <Button asChild data-testid="not-found-home-link" className="bg-orange hover:bg-orange-hover text-white rounded-full px-7 py-6 font-semibold">
          <Link to="/">
            <Home className="w-4 h-4 mr-2" /> Retour à l'accueil
          </Link>
        </Button>
      </section>
      <Footer />
    </div>
  );
}
